import { t } from 'i18next';
import { siteTypeEnum } from '../site';

export const siteTypeLabels: Record<number, string> = {
    [siteTypeEnum.EXTERNAL]: 'external',
    [siteTypeEnum.INTERNAL]: 'internalBillable',
    [siteTypeEnum.TRAINING]: 'training',
    [siteTypeEnum.SPECIAL]: 'special',
};

export const getSiteTypeLabel = (type?: number): string => {
    return type !== undefined && siteTypeLabels[type] ? t(siteTypeLabels[type]) : '';
};
